import { render, staticRenderFns } from "./CardSharing.vue?vue&type=template&id=18ddf4d2&scoped=true&"
import script from "./CardSharing.vue?vue&type=script&lang=js&"
export * from "./CardSharing.vue?vue&type=script&lang=js&"
import style0 from "./CardSharing.vue?vue&type=style&index=0&id=18ddf4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ddf4d2",
  null
  
)

export default component.exports